import CrashDetectionPage from '@/components/feature/CrashDetectionPage'

const CrashDetection = () => {
  return <CrashDetectionPage />
}

export default CrashDetection
